import { useURLSearchParams } from './use_url_search_params';

export const useArrayURLSearchParam = <T extends string = string>(name: string) => {
  const [params, onChange] = useURLSearchParams();

  const value: T[] = params.getAll(name) as T[];

  return [
    value,
    (values: T[]) => {
      onChange((params) => {
        if (!values.length) params.delete(name);
        for (const value of values) {
          params.append(name, value);
        }
        return params;
      });
    },
  ] as const;
};
